import React, { useEffect, useRef, useState } from 'react'
import styles from './styles/banner_slider_style.module.scss'
import SliderButtons from '../slider-buttons/SliderButtons'

const MIN_DISTANCE = 25;

const BannerSlider = ({ images, setIndex }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const touchStartXRef = useRef(null);
    const touchEndXRef = useRef(null);

    setIndex && useEffect(() => {
        setIndex(currentIndex);
    }, [currentIndex])

    const handlePrev = () => {
        setCurrentIndex((prev) => Math.max(prev - 1, 0));
    };

    const handleNext = () => {
        setCurrentIndex((prev) =>
            Math.min(prev + 1, images.length - 1)
        );
    };

    const handleTouchStart = (e) => {
        touchStartXRef.current = e.changedTouches[0].clientX
    };

    const handleTouchEnd = (e) => {
        touchEndXRef.current = e.changedTouches[0].clientX;
        handleSwipe();
    };

    function handleSwipe () {
        const distance = touchStartXRef.current - touchEndXRef.current;
        const testDistance = Math.abs(distance) >= MIN_DISTANCE;

        if (testDistance) {
            if (distance > 0) handleNext()
            else handlePrev()
        }
    }

    return (
        <div className={styles['banner-slider']}
             onTouchStart={handleTouchStart}
             onTouchEnd={handleTouchEnd}
        >
            <div className={styles['banner-slider-track']}>
                {images.map((ItemComponent, index) => (
                    <div key={index} className={`${styles['banner-slider-item']} ${currentIndex === index && styles.visible}`}>
                        {ItemComponent}
                    </div>
                ))}
            </div>

            <div className={styles['banner-slider-buttons']}>
                <SliderButtons currentIndex={currentIndex}
                               totalLevels={images.length}
                               clickLeftButton={handlePrev}
                               clickRightButton={handleNext}
                />
            </div>
        </div>
    );
};

export default BannerSlider;
